import React from 'react';
import { XIcon } from 'lucide-react';
import { handoffs, noMores, productName, simpleMessages } from '../data/content';
import { CtaButton } from './CtaButton';
import { PrintCutShare } from './PrintCutShare';
const tones = ['text-navy', 'text-coral', 'text-navy', 'text-leaf-deep'];
export function SolutionIntro() {
  return <section aria-labelledby="solution-title" className="bg-cream" data-id="element-323" data-mp="3qdz8mydbf58k">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-324" data-mp="hwupwo56su2i">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-325" data-mp="lyze37cv8yhr">
          <div data-id="element-326" data-mp="lyfxpv2v6i5u">
            <h2 id="solution-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-327" data-mp="lwvbcsqpe5j2">
              Was wäre, wenn es einen einfachen Weg gäbe, damit anzufangen?
            </h2>
            <ul className="mt-8 space-y-2" data-id="element-328" data-mp="2spfbyihjhm5f">
              {simpleMessages.map((m, i) => <li key={m} className={`font-display text-2xl leading-snug sm:text-[30px] ${tones[i]}`} data-id="element-329" data-mp="2srs2vl59z6um" data-mpi={i}>
                  {m}
                </li>)}
            </ul>
          </div>
          <div className="lg:pt-4" data-id="element-330" data-mp="2xbr05wo1fu8n">
            <p className="text-lg font-bold text-navy" data-id="element-331" data-mp="2t943nigf9l54">Etwas so Einfaches, dass du es …</p>
            <ul className="mt-5 divide-y divide-cream-line border-y border-cream-line" data-id="element-332" data-mp="378mzpcvyl612">
              {handoffs.map(h => <li key={h} className="py-3.5 text-lg text-ink-soft" data-id="element-333" data-mp="32892kpvwbght">
                  {h}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-20 max-w-3xl text-center" data-id="element-334" data-mp="3c7q733zevoc7">
          <p className="font-display text-3xl leading-tight text-navy sm:text-4xl" data-id="element-335" data-mp="3c5dqau5e3k0q">
            Genau dafür wurde
            <span className="my-1 block text-[24px] leading-tight text-coral sm:text-[34px]" data-id="element-336" data-mp="3kzia4tm3vv6r">{productName}</span>
            entwickelt.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-337" data-mp="3s6dg3utw3wm">
            Eine umfassende Sammlung mit <strong className="text-navy" data-id="element-338" data-mp="3uyzjbl0kgr7h">über 200 Bibelversen</strong> auf{' '}
            <strong className="text-navy" data-id="element-339" data-mp="5w9vhlgyd23c">mehr als 20 druckfertigen Designs</strong> – gemacht für ganz normale Christen, die Gottes Wort einfach,
            praktisch und kreativ weitergeben möchten.
          </p>
          <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-340" data-mp="fswe03lt3h27">
            {noMores.map(n => <li key={n} className="inline-flex max-w-full items-center gap-2 rounded-[22px] bg-white px-4 py-2 font-semibold text-ink-soft shadow-card" data-id="element-341" data-mp="klz8qf2bkwjz">
                <XIcon className="h-4 w-4 shrink-0 text-coral" strokeWidth={3} aria-hidden="true" data-id="element-342" data-mp="tkt27wkct6tb" />
                <span className="text-balance text-left leading-snug" style={{
              textAlign: "center",
              fontSize: "14px"
            }} data-id="element-343" data-mp="ykfhebjqsx4r">{n}</span>
              </li>)}
          </ul>
          <p className="mt-10 font-display text-2xl italic text-ink-soft" data-id="element-344" data-mp="13gwcxqt9udrv">Du musst nur noch …</p>
          <div className="mt-3" data-id="element-345" data-mp="30dvglwtwbkbc">
            <PrintCutShare data-id="element-346" data-mp="35a3ul6wcx7gx" />
          </div>
          <p className="mt-3 font-display text-2xl text-leaf-deep" data-id="element-347" data-mp="35avpefi4r165">Und anfangen zu säen.</p>
          <CtaButton className="mt-8" data-id="element-348" data-mp="2xsnpimazrgwp">Sofort loslegen</CtaButton>
        </div>
      </div>
    </section>;
}